import { Modal } from '@entur/modal';
import ErrorBoundary from 'app/components/ErrorBoundary';
import { useSuspenseOperatingMessages } from 'features/operating-messages/api/getOperatingMessages';
import { Suspense } from 'react';
import { useIntl } from 'react-intl';
import { OperatingMessage } from './OperatingMessage';
import { OperatingMessageDto, WithRequiredId } from 'types';

interface OperatingMessagesModalProps {
  isOpen: boolean;
  onDismiss: () => void;
}

export const OperatingMessagesModal = ({ isOpen, onDismiss }: OperatingMessagesModalProps) => {
  const intl = useIntl();
  return (
    <Modal
      size="medium"
      title={intl.formatMessage({ id: 'menu.operatingMessages' })}
      open={isOpen}
      onDismiss={onDismiss}
    >
      <ErrorBoundary>
        <Suspense fallback={intl.formatMessage({ id: 'generalValues.loading' })}>
          <OperatingMessagesModalContent />
        </Suspense>
      </ErrorBoundary>
    </Modal>
  );
};

const OperatingMessagesModalContent = () => {
  const intl = useIntl();

  const { data: operatingMessagesResponse } = useSuspenseOperatingMessages({
    searchParams: { filterOutdated: true },
  });
  const operatingMessages: WithRequiredId<OperatingMessageDto>[] = operatingMessagesResponse?.data?.items ?? [];

  if (operatingMessages.length === 0) return <p>{intl.formatMessage({ id: 'operatingMessages.noActiveMessages' })}</p>;

  return operatingMessages.map((message) => (
    <OperatingMessage
      key={message.id}
      title={message.title}
      fromDate={message.fromDate}
      toDate={message.toDate}
      description={message.description}
    />
  ));
};
